import { FileCopy, Pageview } from '@mui/icons-material'
import { Chip, Tooltip } from '@mui/material'
import * as React from 'react'
import { tsScreenSampleStatus } from '../../../Typescript/API_Response'
import { useNavigate } from 'react-router-dom'

export function screenSampleStatuses(
  id: number,
  sampleStatus: tsScreenSampleStatus[] | undefined,
) {
  return sampleStatus ? sampleStatus.filter((item) => item.ScreenID === id) : []
}

export function ActionChipBodyRender({
  value,
  tableMeta,
}: {
  value: any
  tableMeta: any
}) {
  const navigate = useNavigate()
  if (tableMeta.rowData[4] === 'DFT') {
    return (
      <Tooltip
        title="Clone"
        style={{ display: 'inline-block' }}
      >
        <Chip
          key={value}
          icon={<FileCopy />}
          size="small"
          style={{ paddingLeft: 8, margin: 3 }}
          onClick={() => handleClone(value, navigate)}
        />
      </Tooltip>
    )
  } else {
    return (
      <>
        <Tooltip
          title="View Request"
          style={{ display: 'inline-block' }}
        >
          <Chip
            key={value}
            icon={<Pageview />}
            size="small"
            style={{ paddingLeft: 8, margin: 3 }}
            onClick={() =>
              navigate({
                pathname: `/stuart/health/screen/${tableMeta.rowData[0]}/collection/`,
              })
            }
          />
        </Tooltip>
        <Tooltip
          title="Clone"
          style={{ display: 'inline-block' }}
        >
          <Chip
            key={value}
            icon={<FileCopy />}
            size="small"
            style={{ paddingLeft: 8, margin: 3 }}
            onClick={() => handleClone(value, navigate)}
          />
        </Tooltip>
      </>
    )
  }
}

const handleClone = (screenID: number, navigate: any) => {
  navigate('../new/clone', { state: { screen: screenID } })
}
